export default {
  bind(el, binding) {
    const { handleScroll } = binding.value;

    el.addEventListener('scroll', handleScroll);
  },

  unbind(el, binding) {
    const { handleScroll } = binding.value;

    el.removeEventListener('scroll', handleScroll);
  },
};
